import React from 'react';

import CriteriaInput from './CriteriaInput';
import Text from './Text';

interface RangeProps {
  displayLabel: string;
  onChangeMin?: (value: string) => void;
  onChangeMax?: (value: string) => void;
  valueMin?: string;
  valueMax?: string;
}
const Range = ({
  displayLabel,
  onChangeMax,
  onChangeMin,
  valueMin,
  valueMax,
}: RangeProps) => (
  <div className="flex flex-col">
    <Text
      as="span"
      text={displayLabel}
      className="text-xs text-gray-500 font-bold my-2"
    />
    <div className="grid grid-cols-2 gap-3">
      {/* Min input */}
      <CriteriaInput
        value={valueMin}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChangeMin && onChangeMin(e.target.value)
        }
        displayLabel="Minimum"
        placeholder="-- ---"
        type="number"
      />
      {/* Max input */}
      <CriteriaInput
        type="number"
        value={valueMax}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChangeMax && onChangeMax(e.target.value)
        }
        displayLabel="Maximum"
        placeholder="-- ---"
      />
    </div>
  </div>
);

export default Range;
